module.exports = __webpack_public_path__ + "static/media/femalenew.505247c3.jpeg";